/**
 * CustomTabPanels — the TrafficPulse Optimisation (CUSTOM) tab bodies: Rules,
 * Queue, Tags, Formula. Split out of FlowOptimizerDrawerTabPanels; each body
 * but Tags lives in ./panels.
 * For Media Devoted | Created By Ciro Autiero
 *
 * The Queue body mounts only for a tracker with a queue (queueProviderOf),
 * and the Tags body only where the profile has campaign-tier tag overrides —
 * so a Tres Commas drawer never builds a queue request or a tag scope.
 */

import type { FC } from 'react';

import { TabsContent } from '@/components/ui/layout/Tabs';
import { TagsTab } from '@/features/flow-optimizer/tabs/tags';

import {
  CalculationPanel,
  QueuePanel,
  RulesPanel,
  SPLIT_PANEL_CLASS,
  type CustomTabPanelsProps,
} from './panels';

export type { CustomTabPanelsProps };

const CustomTabPanels: FC<CustomTabPanelsProps> = (props) => (
  <>
    <RulesPanel {...props} />
    <QueuePanel {...props} />
    {props.profile.tagsTab ? (
      <TabsContent value="tags" className={SPLIT_PANEL_CLASS}>
        {/* Deliberately NOT in the pinned-preview split: the rules read as
            full-width sentences, and the chips they explain are already on
            the Preview tab. */}
        <TagsTab campaignId={props.campaignId} provider={props.provider} />
      </TabsContent>
    ) : null}
    <CalculationPanel {...props} />
  </>
);

export default CustomTabPanels;
